"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScoreFieldGroups = exports.getObservationFieldGroups = exports.EXPORT_FIELD_GROUPS = exports.SCORE_EXPORT_GROUP_FIELDS = exports.SCORE_EXPORT_CORE_FIELDS = exports.SCORE_EXPORT_FIELD_GROUPS = void 0;
const observation_field_groups_1 = require("./observation-field-groups");
/**
 * Field groups of the scores blob export. Named with a `score_` prefix so they
 * never collide with an observation group of the same column (e.g. the
 * observation `metadata` group).
 *
 * Score groups are opt-in: they are not part of any default selection, so
 * existing exports keep their columns and size until a group is selected.
 */
exports.SCORE_EXPORT_FIELD_GROUPS = [
    "score_metadata",
    "score_provenance",
];
/**
 * Columns of every scores export row, in output order. Always exported, so
 * they are not a stored field group; settings show them as a locked "Core"
 * group. Optional group columns are appended after these.
 */
exports.SCORE_EXPORT_CORE_FIELDS = [
    "id",
    "timestamp",
    "project_id",
    "environment",
    "trace_id",
    "observation_id",
    "session_id",
    "dataset_run_id",
    "name",
    "value",
    "source",
    "comment",
    "data_type",
    "string_value",
    "created_at",
    "updated_at",
];
/**
 * Columns each score group adds, appended after the core columns in
 * `SCORE_EXPORT_FIELD_GROUPS` order. Provenance holds the references to where
 * a score came from: author, score config, annotation queue, evaluator.
 */
exports.SCORE_EXPORT_GROUP_FIELDS = {
    score_metadata: ["metadata"],
    score_provenance: [
        "author_user_id",
        "config_id",
        "queue_id",
        "evaluator_id",
        "evaluation_rule_id",
        "execution_trace_id",
    ],
};
/**
 * Every value that can be stored in an integration's `exportFieldGroups`.
 * Each group belongs to exactly one exported table; split a selection with
 * `getObservationFieldGroups` / `getScoreFieldGroups` before handing it to a
 * table's query.
 */
exports.EXPORT_FIELD_GROUPS = [
    ...observation_field_groups_1.OBSERVATION_FIELD_GROUPS_FULL,
    ...exports.SCORE_EXPORT_FIELD_GROUPS,
];
const getObservationFieldGroups = (groups) => groups.filter((group) => observation_field_groups_1.OBSERVATION_FIELD_GROUPS_FULL.includes(group));
exports.getObservationFieldGroups = getObservationFieldGroups;
const getScoreFieldGroups = (groups) => groups.filter((group) => exports.SCORE_EXPORT_FIELD_GROUPS.includes(group));
exports.getScoreFieldGroups = getScoreFieldGroups;
